import init from '../../helpers/init';
import {showAlert} from '../main';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  let mainBlockClass = '.translate-block';

  // показывает выбор языка
  $(document).on('click', '.js-main-lang-selector', function(){
    let p = $(this).parents(mainBlockClass);

    if(p.length){
      if(p.find('.js-main-lang-selector-block').length){
        let b = p.find('.js-main-lang-selector-block');
        if(b.hasClass('active')){
          b.removeClass('active');
        }else{
          b.addClass('active');
        }
      }
    }
  });

  // перевод
  $(document).on('click', '.js-submit-translate', function(e){
    e.preventDefault();

    let p = $(this).parents(mainBlockClass);

    if(p.length){
      if(p.find('.js-main-lang-selector-block').length){
        if($(this).attr('data-id')
          && $(this).attr('data-id') !== undefined
          && p.find('.js-main-lang-selector-source').val()
          && $(this).attr('data-content')
          && $(this).attr('data-content') !== undefined
          && $(this).attr('data-entity-type')
          && $(this).attr('data-entity-type') !== undefined
          && $(this).attr('data-translate-enable-type')
          && $(this).attr('data-translate-enable-type') !== undefined
        ){
          let id = $(this).attr('data-id');
          let content = JSON.parse($(this).attr('data-content'));

          const data = {
            text: content,
            sourceLang: p.find('.js-main-lang-selector-source').val(),
            targetLang: p.find('.js-main-lang-selector-target').val(),
            id: id,
            entityType: $(this).attr('data-entity-type'),
            enableEntityType: $(this).attr('data-translate-enable-type')
          }

          // переводим
          BX.ajax.runComponentAction('pwd:translate.language.selector', 'translate', {
            data,
            mode: 'class'
          }).then((result: any) => {
            if (result.data != 0) {
              location.reload();
            }else{
              showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Problems with translation. Try later' : 'Возникли проблемы при переводе. Попробуйте позже.');
            }
          }).catch((err: any) => {
            showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
            console.log(err);
          });
        }
      }
    }
  });
});
